/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-TooltipExample{margin-top:30px;text-align:center}"}]);
/* tslint:enable */
